<template>
    <el-cascader
        :options="address.options"
        @active-item-change="handleItemChange"
        @change="handleChange"
        :props="address.props"
        v-model="areainfo"
        ></el-cascader>
</template>
<script>
import {searchAreasInfo} from '@/api/mediator'

export default {
    model: {
        prop: 'areacode',//相当于areainfo=areacode
        event: 'callbackarea'
    },
    data() {
        return {
            address: {
                options:[],
                values:[],
                texts:[],
                props:{
                    value: 'code',
                    label:'name',
                    children: 'cities'
                }
            },
            areaCodeList:[],
            onloadstatus:false,
            areainfo:[]
        }
    },
    props: ['areacode','comtransmit'],
    mounted() {
        this.areaCodeList = this.areacode
        this.getAreaInfoData()
    },
    watch: {
        areacode: {
            handler: function (newData, oldData) {
                let self = this;
                self.$nextTick(function () {
                    this.areaCodeList = this.areacode
                    self.getAreaInfoData()
                })
            }
        }
    },
    methods: {
        getAreaInfoData() {
            let self = this, areacodearray = [], count = 0;
            self.address.options = []
            //this.getAreaNodes([])
            if(Boolean(self.comtransmit.code)&&Boolean(self.comtransmit.name)){
                self.address.options.push({code:self.comtransmit.code,name:self.comtransmit.name,cities:[]})
                areacodearray.push(self.comtransmit.code)
                count++
            }
            const seachArea = () => {
                let self = this
                if(self.areaCodeList && self.areaCodeList.length > count&&Boolean(self.areaCodeList[count])){
                    let parentid = areacodearray?areacodearray.slice(-1)[0]:'',
                        level = areacodearray.length+1
                    searchAreasInfo({
                        "level": level,
                        "parentCode":parentid
                    }).then((res) => {
                        self.addAreaNodes(self.address.options,areacodearray,res.data.data,level)
                        areacodearray.push(self.areaCodeList[count])
                        count++
                        if(count == self.areaCodeList.length) {
                            self.areaecho()
                        }
                        seachArea()
                    })
                }else if(count === 0){
                    this.getAreaNodes([])
                }
            }
            seachArea()
        },
        areaecho() {
            this.onloadstatus = true
            this.areainfo = this.areaCodeList
        },
        resetData(){
            if(this.onloadstatus){
                this.areainfo = this.areaCodeList
            }
        },
        addAreaNodes(data,code,res,level) {
            let self = this
            if(code.length){
                if(code.length > 1) {
                    data.forEach((d,i) => {
                        if(d.code == code[0]) {
                            self.addAreaNodes(d.cities,code.slice(1-code.length),res,level)
                        }
                    })
                }else{
                    data.forEach((d,i) => {
                        if(d.code == code[0]) {
                            if(res) {
                                d.cities = []
                                if(level !== 4){
                                    res.forEach(function(r){
                                        d.cities.push({code:r.code,name:r.name,cities:[]});
                                    })
                                }else{
                                    if(res.length == 0) {
                                        d.cities = [{code:d.code,name:d.name}]
                                    }else {
                                        res.forEach(function(r){
                                            d.cities.push({code:r.code,name:r.name});
                                        })
                                    }
                                }
                            }
                            if(self.address.texts[level-2]){
                                self.address.texts[level-2]=d.name
                            }else{
                                self.address.texts.push(d.name)
                            }
                        }
                    })
                }
            }else{
                res.forEach(function(r){
                    data.push({code:r.code,name:r.name,cities:[]});
                })
            }
            self.address.options = data

        },
        getAreaNodes(val) {
            let parentid = val?val.slice(-1)[0]:'',
                self = this,
                level = val.length+1
            searchAreasInfo({
                "level": level,
                "parentCode":parentid
            }).then((res) => {
                self.addAreaNodes(self.address.options,val,res.data.data,level)
            },(errir) =>{

            })
        },
        handleItemChange(val) {
            this.getAreaNodes(val)
        },
        handleChange (val){
            this.address.values = val
            this.addAreaNodes(this.address.options,val,'',5)
            this.$emit('comcallback', {
                index:this.comtransmit.index,
                type:this.comtransmit.type,
                code:this.address.values,
                names:this.address.texts})
            // this.$emit('callbackarea', val)
        }
    }
}
</script>
